<section class="service-page">
  <div class="row pad">
    <div class="service-page__inner">
      <div class="text-muted">13 October 2026</div>
      <h1>Mubadala Abu Dhabi Open Privacy Notice</h1>

      <p>
        We are committed to protecting the Personal Information of those
        individuals whose data we collect and process.
      </p>

      <h2>Who are we?</h2>

      <p>
        We are AE EventsCo Holdings LLC. We are also part of MARI Group and its
        affiliated entities (collectively, “MARI”). We will collectively refer
        to ourselves as the “Company,” “we,” “our,” or “us”.
      </p>

      <h2>What is this privacy notice about?</h2>

      <p>
        This Privacy Notice (“Notice”) describes how we use the data we collect
        from and about you when you visit our websites and applications
        (collectively, the “Site”), when you buy a ticket or other merchandise
        from us, when you view or interact with our content, when you attend our
        events in person, and when you otherwise interact with us, including our
        social media, marketing, contests, sweepstakes, and surveys
        (collectively our “Services”). Like any company, we use a variety of
        third-party businesses and partners to market and provide our Services
        to you. Some of those companies are our affiliates and some are third
        parties that we partner with or support our operations so we can provide
        you with the best experience.
      </p>

      <p>
        “Personal Information” means any information related to an identified or
        identifiable natural person. Personal Information includes data
        regulated as “personal data” and “personally identifiable information”
        under the law in various jurisdictions. Personal Information does not
        include anonymized data from which we cannot reasonably identify any
        natural person.
      </p>

      <p>
        If you are sharing another person’s Personal Information, you are
        responsible for ensuring that they have consented to sharing that
        Personal Information with us and for ensuring that they are aware of
        this Notice.
      </p>

      <p>
        Where permitted by applicable law, you accept the terms of this Notice
        by using the Site, participating in our events, and/or receiving
        services from us.
      </p>

      <h2>What Personal Information do we collect?</h2>

      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th>Category</th>
              <th>Types of Information</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Personal and online identifiers</td>
              <td>
                first and last name, username, online identifiers (such as IP
                address)
              </td>
            </tr>
            <tr>
              <td>Contact information</td>
              <td>
                email address, phone number, address, and the components of
                those data elements, such as zip code, area code, and state or
                province
              </td>
            </tr>
            <tr>
              <td>Billing information</td>
              <td>
                credit/debit card numbers and associated data (such as expiry
                date), bank account information, other account information (such
                as Venmo, Paypal or other payment applications), information for
                other forms of payment that you made provide
              </td>
            </tr>
            <tr>
              <td>Customer profile</td>
              <td>
                your preferences (such as information about events you enjoy or
                entertainment you are interested in or a language preference)
              </td>
            </tr>
            <tr>
              <td>Transactional information</td>
              <td>
                Ticket buying history, attendance at events, memberships,
                subscriptions, other purchase history
              </td>
            </tr>
            <tr>
              <td>Communications with or by you</td>
              <td>
                emails that you send seeking assistance and any response,
                information you post in a public space on our website or on a
                third-party social media site that tags or mentions our event or
                company
              </td>
            </tr>
            <tr>
              <td>Online activity</td>
              <td>
                browsing history, search history, video viewing history,
                interactions with our Site, email, or advertisement, IP address,
                general location (such as country or area) based on IP address
              </td>
            </tr>
            <tr>
              <td>Ticket usage information</td>
              <td>
                When you arrive at an event and use your ticket, we are aware
                that you are at the entrance at a particular time
              </td>
            </tr>
            <tr>
              <td>Photographs and recordings</td>
              <td>
                CCTV, pictures taken at the event, event activities that may
                involve recording and/or photographs
              </td>
            </tr>
            <tr>
              <td>Other information that you may voluntarily share with us</td>
              <td>
                Feedback or comments you may provide while at an event and any
                other information that you choose to share
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <p>
        We do not collect sensitive Personal Information from you, unless you
        voluntarily provide that information to us. We do not offer our Services
        or promote the Site to, nor do we intentionally collect or retain
        Personal Information from, children who are younger than 18 years of
        age. If we discover that we have inadvertently collected Personal
        Information from a child under 18 years of age, we will promptly take
        all reasonable measures to delete such information from our systems.
      </p>

      <p>
        We may collect deidentified or pseudonymized information from you that
        may not by itself reasonably identify you as the source of the
        information (“Deidentified Information”). This Deidentified Information
        is collected when you navigate the Site and may include:
      </p>

      <ul>
        <li>device type;</li>
        <li>device operating system;</li>
        <li>internet browser type;</li>
        <li>internet service provider;</li>
        <li>referring/exit pages;</li>
        <li>date/time stamp; and</li>
        <li>clickstream information.</li>
      </ul>

      <p>
        We will take reasonable measures to ensure that Deidentified Information
        we collect is not reasonably identifiable and may not later be easily
        used to identify you.
      </p>

      <h2>How do we collect Personal Information?</h2>

      <p>
        <strong>Directly from you.</strong> You may provide us with Personal
        Information in several ways, such as when you:
      </p>

      <ul>
        <li>
          Provide information to us via our Site by signing up, creating
          accounts (including using social media login), filling out forms,
          commenting, or otherwise engaging with our online Services
        </li>
        <li>Communicate with us by e-mail or phone</li>
        <li>Subscribe to e-mails and/or newsletters</li>
        <li>Report a problem or request support for any of our Services</li>
        <li>Buy a ticket or merchandise from us online</li>
        <li>Interact with our social media accounts</li>
        <li>
          Participate in our contests, promotions, sweepstakes, or surveys
        </li>
        <li>
          Subscribe to our content online including using any of our online
          social media channels, official video, or streaming partners
        </li>
        <li>
          Attend an event (such as ticket scanning, CCTV, and other on location
          interactions you may have with us)
        </li>
      </ul>

      <p>
        <strong>Through your use of our websites.</strong> We may collect
        Personal Information that your browser transmits when you visit the
        Site. We may also collect Deidentified Information about how you access
        and interact with the Site through automated tracking technologies, such
        as session cookies, persistent cookies, and web beacons (also known as
        tracking pixels). There is more information about these technologies and
        your choices about them in the “How do we use cookies or other tracking
        technologies?” section.
      </p>

      <p>
        <strong>From other sources.</strong> We may receive information about
        you from a few types of other sources:
      </p>

      <ul>
        <li>
          <strong>Service providers</strong>: For certain events, we may work
          with other companies to provide the services that you seek. For
          example, we may use a third-party ticketing company and that company
          may share your information with us. In some cases, third parties also
          provide us with information that helps us keep track of transactions,
          address technical or logistical issues, prevent fraud, or keep our
          community safe from security threats.
        </li>
        <li>
          <strong>Business partners:</strong> We work closely with third parties
          (for example, promotions companies, advertising networks, analytics
          providers, and search information providers) and may receive
          information about you from them. Depending on the relationship and
          activity, they will provide us with certain information that will help
          us understand how you interact with our Services so we can tailor our
          marketing and provide better, more personalized Services to you. Some
          of our key partners, who we receive data from and may share some data
          with include:
          <ul>
            <li>
              Event partners and sponsors, who we work with to host events and
              offer the activities available at the events
            </li>
            <li>
              Media and digital content partners, who we partner with to share
              exclusive content of events
            </li>
            <li>
              E-commerce platforms and services, which provide merchandise
            </li>
            <li>
              Venues that host our events and provide various marketing,
              advertising, customer support, and security services related to
              our events
            </li>
          </ul>
        </li>
        <li>
          <strong>Affiliates</strong>: We may share information across our
          affiliated companies to provide you with better service and
          information about events in which you may be interested.
        </li>
        <li>
          <strong>Social media or technology platforms:</strong> We may receive
          and display information and content which you make publicly available
          on your social media account when you use social media logins for our
          Services or interact with any of our content (such as contests). We
          may also receive and display information and content which you make
          publicly available on your social media account, such as when you post
          using one of our promoted hashtags.
        </li>
      </ul>

      <p>
        We may combine Personal Information we receive from other sources with
        Personal Information you give to us and Personal Information we collect
        about you.
      </p>

      <h2>For what purposes do we use Personal Information?</h2>

      <p>We use Personal Information for the following purposes:</p>

      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th>Purpose</th>
              <th>Categories of Personal Information Used</th>
              <th>Legal Basis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong>To Provide Our Services</strong>: We may use your
                Personal Information to process your order, provide the Services
                you seek, and deliver support related to your selected event.
                This includes using your payment information to sell you our
                Services, including tickets, merchandise, activities, and other
                content.
              </td>
              <td>
                Personal and online identifiers, contact information, billing
                information, communications with and by you, transactional
                information, ticket usage information, other information that
                you may voluntarily share with us
              </td>
              <td>As necessary for the performance of a contract</td>
            </tr>
            <tr>
              <td>
                <strong>Customer Service and Communications</strong>: We may use
                your Personal Information to help us respond to your inquiries,
                questions, requests, and support your needs more efficiently.
              </td>
              <td>Any Personal Information</td>
              <td>
                Where applicable, as necessary for the performance of a
                contract<br />Otherwise, legitimate interest
              </td>
            </tr>
            <tr>
              <td>
                <strong>User Experience Personalization</strong>: We may use
                Personal Information and/or Deidentified Information in the
                aggregate to analyze browsing and usage activities and patterns
                to understand interests and preferences with respect to the Site
                and our Services. This will help us optimize your experience at
                an event and on the Site, for example, by displaying content
                based upon your preferences.
              </td>
              <td>
                Personal and online identifiers, customer profile,
                communications with and by you, online activity, ticket usage
                information, other information that you may voluntarily share
                with us
              </td>
              <td>Legitimate interest</td>
            </tr>
            <tr>
              <td>
                <strong
                  >Safety, Security, Fraud Prevention and Cybersecurity:</strong
                >
                We may use your Personal Information and/or Deidentified
                Information to protect your safety and security and the safety
                and security of our Services and community. For example, we may
                use the information to authenticate users, facilitate secure
                payments, respond to a legal request or claim, conduct audits,
                enforce our terms and policies, and to ensure physical safety in
                the case of an emergency. We may use Personal Information to
                detect and prevent fraud and ensure the security of our
                electronic networks and systems. Processing for safety and
                security may include the use of artificial intelligence (“AI”).
              </td>
              <td>Any Personal Information</td>
              <td>
                Where applicable, to comply with applicable local law<br />Otherwise,
                legitimate interest
              </td>
            </tr>
            <tr>
              <td>
                <strong>Marketing and Targeted Advertising:</strong> We may use
                your Personal Information to send you promotional materials and
                event reminders and to conduct targeted advertising. We obtain
                consent in advance where required by law. Otherwise, you have
                the right to opt out from receiving marketing messages as
                described below.
              </td>
              <td>
                Personal and online identifiers, contact information, customer
                profile information, communications with you, online activity
              </td>
              <td>
                Where required by law, consent<br />Otherwise, legitimate
                interest
              </td>
            </tr>
            <tr>
              <td>
                <strong>Business Optimization</strong>: We may use your Personal
                Information to improve the content on and layout of our Site,
                and in managing our everyday business needs. We use data about
                the events and Services we provide to determine what aspects
                people enjoy and what improvements we can make. We may also use
                your feedback to improve the Site and our Services. All of this
                is done with the intention of making the Site and Services more
                enjoyable and useful for you.
              </td>
              <td>
                Customer profile, transactional information, communications with
                or by you, online activity, other information that you may
                voluntarily share with us
              </td>
              <td>Legitimate interest</td>
            </tr>
            <tr>
              <td>
                <strong>Legally Required</strong>: We may use Personal
                Information as may be required to fulfill our legal obligations
                or protect our legal rights.
              </td>
              <td>Any Personal Information</td>
              <td>
                Where applicable, legal obligation<br />Otherwise, legitimate
                interest
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <p>
        Unless required to do so by law, we will not collect additional
        categories of Personal Information or use Personal Information we
        collected for materially different, unrelated, or incompatible purposes
        without providing you notice and seeking your consent.
      </p>

      <h2>Where do we store Personal Information?</h2>

      <p>
        We are based in the United States and primarily store and process
        Personal Information in the United States. If you choose to provide your
        Personal Information to us, you are transferring your data to the United
        States. Because we are part of MARI Group, an international group of
        companies, we may also transfer or share your Personal Information to
        MARI Group entities and service providers located outside the country in
        which you reside and outside of the United States, but will do so only
        consistent with applicable law. If you have any questions about our data
        transfer practices, please contact us as described in the section titled
        “How can you contact us?” at the end of this Notice.
      </p>

      <h2>To whom might we disclose Personal Information?</h2>

      <p>
        We may disclose your Personal Information to the following third parties
        only as necessary for one of the purposes listed above:
      </p>

      <ul>
        <li>
          <strong>Event partners:</strong> We offer various opportunities at our
          events, which may be provided by business partners, suppliers, and
          sub-contractors. You may share your Personal Information directly with
          our event partners to participate and/or make a purchase. We may also
          share your Personal Information to facilitate your participation, such
          as sharing ticketing information to enable you to receive the Services
          that you have purchased. If you provide feedback about any of the
          opportunities at any of our events, we may share that feedback with
          the relevant business partner, supplier, or sub-contractor to allow
          them to remedy any concerns, improve their services, and/or receive
          positive feedback.
        </li>
        <li>
          <strong>Event sponsors</strong>: We work with business partners to
          sponsor our event. We may share your Personal Information with these
          sponsors so that they may share relevant information with you about
          promotions and offers.
        </li>
        <li>
          <strong>Service providers</strong>: We use suppliers to provide,
          improve, and tell you about the Services. These service providers
          include, for example, technology vendors, advertisers, marketing and
          social media consultants, analytics consultants, and search engine
          providers. These service providers may assist us:
          <ul>
            <li>
              With business operations, such as e-commerce and payment platform
              providers;
            </li>
            <li>
              To provide you with information about promotions and offers;
            </li>
            <li>
              To select and serve relevant advertisements to you and, in some
              cases, to others; and
            </li>
            <li>In the improvement and optimization of the Services.</li>
          </ul>
        </li>
        <li>
          <strong>Our Affiliates:</strong> We may disclose your Personal
          Information to other legal entities in the MARI Group, including our
          parent company and other subsidiaries and affiliates of our parent
          company.
        </li>
        <li>
          <strong>Law Enforcement, Safety, and Legal Processes:</strong> We may
          disclose your Personal Information to outside counsel, law enforcement
          or other government officials if it relates to a criminal
          investigation or alleged criminal activity. We may also disclose your
          Personal Information: (i) if required to do so by law; (ii) for fraud
          protection and credit risk reduction purposes; (iii) in the good-faith
          belief that such action is necessary to protect our rights, interests,
          or property; (iv) in the good-faith belief that such action is
          necessary to protect your safety or the safety of others; or (v) to
          comply with a judicial proceeding, court order, subpoena, or other
          similar legal or administrative process.
        </li>
        <li>
          <strong>Sale or Acquisition of Assets:</strong> If we become involved
          in a transaction involving the sale of some or all of our assets, such
          as a merger, acquisition, or bankruptcy, or if we are transferred to
          another company, we may disclose and/or transfer your Personal
          Information as part of the transaction. If the surviving entity in
          that transaction is not us, the surviving company may use your
          Personal Information pursuant to its own privacy notice, which may be
          different from this Notice.
        </li>
        <li>
          <strong>As you direct:</strong> We may also disclose your Personal
          Information to any other third party at your direction or with your
          prior consent.
        </li>
      </ul>

      <p>
        As further detailed in the section below about your legal rights and
        choices, you can opt-out of sharing with any party for marketing or
        advertising by contacting us as indicated in the “How can you contact
        us?” section at the bottom of this Notice.
      </p>

      <h2>How do we protect Personal Information?</h2>

      <p>
        The security and confidentiality of your Personal Information is very
        important to us. We use commercially reasonable security measures to
        protect your Personal Information. We use a variety of administrative,
        physical, and technological solutions to protect your information from
        unauthorized access, loss, or misuse. Because there is always some risk
        in transmitting information over the internet and otherwise processing
        information, we cannot guarantee or warrant that your Personal
        Information will be completely secure from misappropriation by hackers
        or other criminal actors, or in the event of a system or network
        compromise.
      </p>

      <h2>How long do we retain Personal Information?</h2>

      <p>
        We will retain your Personal Information while you maintain an account
        with us or to the extent necessary to provide the Services. Thereafter,
        we retain your Personal Information for as long as reasonably necessary:
        (1) to respond to any queries; (2) to log a response to a request
        related to your legal rights; (3) for ordinary business continuity
        procedures; or (4) to comply with any applicable laws. We delete
        Personal Information within a reasonable period after we no longer need
        the information for the purposes set out in this Notice.
      </p>

      <h2>
        What are your legal rights and choices about your Personal Information?
      </h2>

      <p>
        If you ever wish to access, update, change, delete, opt-out of us
        sharing, or otherwise control your Personal Information, you may do so
        by contacting us using one of the methods in the “How can you contact
        us?” section. To help us process your request, please provide sufficient
        information to allow us to identify you in our records. We reserve the
        right to ask for additional information verifying your identity prior to
        disclosing any Personal Information to you. Should we ask for
        verification, we will only ask to confirm Personal Information that we
        already have about you and the information you provide will be used only
        for verification purposes. We will make commercially reasonable efforts
        to respond to opt-out requests and handle requests to access, update,
        change, or delete Personal Information without unreasonable delay.
      </p>

      <p>
        <strong>Marketing messages.</strong> We ensure that we obtain consent in
        advance in those jurisdictions that require it for marketing
        communications. If you want to opt-out of marketing communications, you
        can:
      </p>

      <ul>
        <li>
          Emails: use the “unsubscribe” option at the bottom of the message
        </li>
        <li>Text messages: reply “STOP” to the message</li>
        <li>
          All communications: contact us using one of the methods in the “How
          can you contact us?” section
        </li>
      </ul>

      <p>
        Please be aware that although you may opt-out of marketing
        communications, we may still need to send you operational or
        administrative messages. Also, we can only opt you out of marketing
        communications from the email address or text number that you provide to
        us, as a search for your name be relate to another individual with the
        same name.
      </p>

      <p>
        <strong>Targeted Advertising.</strong> We use your Personal Information
        to tailor our marketing and advertising efforts. In using this
        information, we utilize our cookies banner to provide you with options
        and we respect the choices that you make. Where you allow us, we provide
        your information to third party advertising networks (such as Google
        DoubleClick) and social media companies (such as Facebook
      </p>

      <p>
        <strong>Opting Out of the Sale of your Personal Information.</strong>
        Sometimes we share your data with sponsors, vendors, other MARI
        companies, and third-party advertising networks. These transfers, which
        are used to provide you with certain Services and/or to more effectively
        provide you with personalized Services (including advertising), can be
        deemed a sale under some data privacy laws.
      </p>

      <p>
        Depending on your jurisdiction, you may have the right to opt out of the
        sale of your Personal Information by clicking on the Do Not Sell My
        Personal Information link
        <a
          href="https://privacyportal.onetrust.com/webform/889c435d-64b4-46d8-ad05-06332fe1d097/29f00c5b-29a8-440a-a5f4-ac57910fb878"
          target="_blank"
          rel="noopener noreferrer"
          ><strong>here</strong></a
        >, or at the bottom of our homepage. You may also email
        <a href="mailto:dataprivacy@marigrp.com">dataprivacy@marigrp.com</a>.
      </p>

      <p>
        You will be asked to provide certain information to us in order to
        exercise this option so we can verify your identity and locate your
        records with us.
      </p>

      <p>
        <strong
          >EU, UK, and Switzerland residents and those residing in other
          countries with a GDPR-similar law:</strong
        >
        You have the right to:
      </p>

      <ul>
        <li>Access your Personal Information (to request a copy);</li>
        <li>Ask that we correct any mistakes in your Personal Information;</li>
        <li>Request that we delete your Personal Information;</li>
        <li>
          Object to or restrict the processing of your Personal Information
          partially or completely, including to any automated individual
          decision-making or profiling; and
        </li>
        <li>
          Obtain the Personal Information that you provided to us in a
          structured, commonly used, and machine-readable format.
        </li>
      </ul>

      <p>
        To exercise your rights, please use one of the methods mention in the
        “How can you contact us?” section. Please be aware that your rights
        (including those enumerated elsewhere in this Notice) may be limited by
        other applicable legal rights and obligations. You also have the right
        to lodge a complaint with your national regulatory authority (also known
        as a supervisory authority).
      </p>

      <p>
        <strong>UK residents:</strong> If you have a complaint about how we have
        handled your personal data, you may submit a complaint using the contact
        methods listed below in the “How can you contact us?” section. We will
        endeavor to acknowledge receipt within 30 days, may request additional
        information to verify your identity or clarify the scope of your
        complaint, and will keep you updated on the investigation and its
        outcome without undue delay. If you are not satisfied with the outcome,
        you have the right to complain to the Information Commissioner's Office
        (ICO), which can be contacted at
        <a href="https://ico.org.uk/" target="_blank" rel="noopener noreferrer"
          >https://ico.org.uk/</a
        >.
      </p>

      <p>
        <strong>EU residents:</strong> You also have the right to lodge a
        complaint with your national or state data protection authority
        (supervisory authority). You can find contact information for the EU
        data protection authorities at
        <a
          href="https://www.edpb.europa.eu/about-edpb/our-members_en"
          target="_blank"
          rel="noopener noreferrer"
          >https://www.edpb.europa.eu/about-edpb/our-members_en</a
        >.
      </p>

      <p>
        <strong>US residents:</strong> If you are a resident of certain states
        in the United States, you have the following rights:
      </p>

      <ul>
        <li>
          Right to know about the Personal Information we have collected about
          you and how it is used and shared;
        </li>
        <li>
          Right to delete Personal Information collected from you (with some
          exceptions);
        </li>
        <li>
          Right to opt-out of the sale or sharing of your Personal Information;
        </li>
        <li>
          Right to not be discriminated against for exercising your privacy
          rights;
        </li>
        <li>
          Right to correct inaccurate Personal Information if we have incorrect
          Personal Information about you; and
        </li>
        <li>
          The right to limit the use and disclosure of sensitive Personal
          Information collected, however, this right does not apply as we do not
          collect sensitive Personal Information.
        </li>
      </ul>

      <p>
        To exercise your rights, please use one of the methods mention in the
        “How can you contact us?” section. Please be aware that your rights
        (including those enumerated elsewhere in this Notice) may be limited by
        other applicable legal rights and obligations.
      </p>

      <p>
        <strong>California residents:</strong> California’s “Shine the Light”
        law permits California residents to request certain information
        regarding our disclosure of Personal Information to third parties for
        their direct marketing purposes. To make such a request, please use one
        of the methods mention in the “How can you contact us?” section.
      </p>

      <h2>How do we use cookies or other tracking technologies?</h2>

      <p>
        A cookie is a small data file that is transferred to an internet
        browser, which enables the Site to remember and customize your
        subsequent visits. Additionally, we may use web beacons (also called
        tracking pixels), which are single-pixel, electronic images embedded in
        the Site that allow us to gather information about your browsing
        activities on the Site. We use cookies and web beacons to enhance your
        browsing experience, serve personalized content, and analyze our
        traffic. You can choose which types of cookies to allow by selecting
        “Manage Preferences” in the banner on our Site.
      </p>

      <p>
        <strong>Global Privacy Controls.</strong> We recognize user-initiated
        opt-out preference signals sent by your web browser, such as the global
        privacy control (“GPC”), as a valid request to opt-out of the sale and
        sharing of Personal Information processed on this website (i.e., through
        cookies and tracking technologies). For more information about GPC and
        how to implement it on your browser, please visit
        <a
          href="https://globalprivacycontrols.org/"
          target="_blank"
          rel="noopener noreferrer"
          >globalprivacycontrols.org</a
        >.
      </p>

      <p>
        <strong>Do Not Track.</strong> Please note that certain web browsers may
        also transmit “do-not-track” signals to the websites with which the user
        communicates. Because there currently is no industry standard concerning
        what, if anything, websites should do when they receive such signals, we
        do not alter our practices when the website receives a “do-not-track”
        signal from a visitor’s browser.
      </p>

      <h2>What should you know about third party links?</h2>

      <p>
        Our Services, newsletters, email updates and other communications may
        contain links to other websites or applications (“Linked Sites”),
        including our partner networks, retail partners, advertisers and
        affiliates. These Linked Sites are not owned or controlled by us. We do
        not control the collection or use of any information, including Personal
        Information, which occurs while you visit Linked Sites. If you follow a
        link to any of these websites, please note that the Linked Sites likely
        have their own privacy notices and that we do not accept any
        responsibility or liability for these notices. Therefore, we make no
        representations or warranties for —and will not in any way be liable
        for—any content, products, services, software, or other materials
        available on Linked Sites.
      </p>

      <p>
        You may be able to use social sharing features and other integrated
        tools on the Site such as the Facebook "Like" button. These features and
        tools may permit you to share actions you take on our Services with
        other media, and vice versa. Your use of such features enables the
        sharing of information with your friends or the public, depending on the
        settings you establish with the service that provides the social sharing
        feature. Please remember that use of the information you share on social
        media sites will be governed by the privacy notices of the social media
        provider, and we are not responsible for how they treat the information.
      </p>

      <h2>How will we keep this notice up to date?</h2>

      <p>
        We reserve the right to update this Notice from time-to-time in our sole
        discretion. If our privacy practices change materially in the future, we
        will post an updated version of this Notice to the Site. It is your
        responsibility to review this Notice for any changes each time you use
        the Site. We will not lessen your rights under this Notice without your
        explicit consent. If you do not agree with the changes made, we will
        honor any opt-out requests made after the effective date of a new
        privacy notice.
      </p>

      <h2>What is the effective date of this notice?</h2>

      <p>
        This Notice was last modified as of the effective date printed above.
        This version of the privacy policy replaces and supersedes any prior
        privacy policies applicable to the Site.
      </p>

      <h2>How can you contact us?</h2>

      <p>
        You can exercise your data privacy (data protection) rights (make a
        “Request”), ask a question about this Notice, inquire about our privacy
        compliance program, or ask any other question about your Personal
        Information by:
      </p>

      <ul>
        <li>
          Using our
          <a
            href="https://privacyportal.onetrust.com/webform/889c435d-64b4-46d8-ad05-06332fe1d097/132dec60-db4a-433d-9873-32b729def610"
            target="_blank"
            rel="noopener noreferrer"
            ><strong>webform</strong></a
          >; or
        </li>
        <li>
          Emailing
          <a href="mailto:dataprivacy@marigrp.com">dataprivacy@marigrp.com</a>
          and reference in your communication that your request pertains to the
          Mubadala Abu Dhabi Open.
        </li>
        <li>
          To unsubscribe from our newsletter or any marketing messages, you can
          use the unsubscribe feature at the bottom of the email or type “Stop”
          in response to a text message.
        </li>
      </ul>

      <p>
        Only you, or someone legally authorized to act on your behalf, may make
        a Request related to your Personal Information. Making a Request does
        not require you to have or create an account with us. Some states impose
        a limit on the number of Requests you can make in a year.
      </p>

      <p>Your Request must:</p>

      <ul>
        <li>
          Provide sufficient information that allows us to reasonably verify you
          are the person about whom we collected Personal Information (or that
          person’s authorized representative); and
        </li>
        <li>
          Describe what you are seeking with sufficient detail that allows us to
          properly understand, evaluate, and respond to it.
        </li>
      </ul>

      <p>
        We cannot respond to your Request or provide you with Personal
        Information if we cannot verify your identity or authority to make the
        request and confirm the Personal Information relates to you. We will
        only use Personal Information provided in a Request to verify the
        requestor’s identity or authority to make the request and to process the
        Request.
      </p>

      <p>
        We will acknowledge receipt of a Request within ten (10) days. We
        endeavor to respond to Requests within thirty (30) days of receipt. If
        we require more time (up to ninety (90) days), we will inform you of the
        reason and extension period in writing. If we cannot comply with a
        Request in whole or in part, we will explain the reason. If we do not
        grant your request, you have the right to appeal to us directly, using
        any of the contact methods (other than the unsubscribe options). In your
        appeal, you must state the reason for your appeal and what you are
        seeking. If you appeal, we will provide a written reply within 60 days
        of receipt of your appeal.
      </p>

      <p>
        We do not charge a fee to process or respond to a Request, unless it is
        excessive, repetitive, or unreasonable. If we determine that the Request
        warrants a fee, we will tell you why we made that decision and provide
        you with a cost estimate before completing your Request.
      </p>

      <p>
        We may retain certain information for recordkeeping or to complete
        transactions initiated before your request.
      </p>
    </div>
  </div>
</section>
